export default __webpack_public_path__ + "static/zoolander-portrait-0f4f552c13dea85e6da3f486b8863da7.jpg";